import React from 'react';
import AlgorithmVisualizer from './components/AlgorithmVisualizer';
import './App.css';

function App() {
  return (
    <div className="App min-h-screen bg-gray-900 py-8 px-4">
      <AlgorithmVisualizer />
    </div>
  );
}

export default App;